import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {PromotionDetail} from '@app/core/promotion/domain/dtos/promotion-detail';
import {PromotionDetailViewModel} from '../promotion-detail.view-model';
import {register} from 'swiper/element/bundle';

@Component({
  selector: 'app-promotion-detail-mobile',
  templateUrl: './promotion-detail-mobile.component.html',
  styleUrls: ['./promotion-detail-mobile.component.scss']
})
export class PromotionDetailMobileComponent implements OnChanges, OnInit {

  @Input() promotionDetail?: PromotionDetail;

  productCodes: string[] = [];

  isLoggedIn$ = this.viewModel.isLoggedIn$;

  isPriceHidden$ = this.viewModel.isPriceHidden$;

  imageViewerVisibility = false;

  constructor(
    private viewModel: PromotionDetailViewModel
  ) { }

  ngOnChanges(): void {
    this.productCodes = this.promotionDetail ? this.promotionDetail.details.map(detail => detail.code) : [];
  }

  ngOnInit(): void {
    register();
  }
  openImageViewer() {
    this.imageViewerVisibility = true;
  }

  closeImageViewer() {
    this.imageViewerVisibility = false;
  }

}
